import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators, compose } from 'redux';
import * as action from './actions';
import { makeSelectMessageDetail } from './selectors';
import './_capGenieBot.scss';
import CapIcon from '../../CapIcon';
import CapRow from '../../CapRow';
import CapModal from '../../CapModal';
import CapButton from '../../CapButton';
import CapHeader from '../../CapHeader';
import CapTable from '../../CapTable';
import CapColoredTag from '../../CapColoredTag';
import CapNotification from '../../CapNotification';
import CapSelect from '../../CapSelect';
import CapGraph from '../../CapGraph';
import CapLabel from '../../CapLabel';
import CapInfoNote from '../../CapInfoNote';
import CapLink from '../../CapLink';
import CapInput from '../../CapInput';
import CapTooltip from '../../CapTooltip';
import CapSkeleton from '../../CapSkeleton';
import CapStepsAccordian from '../../CapStepsAccordian';
import AiraContainer from '../UtilComponents/AiraContainer';
import LocaleHoc from '../../LocaleHoc';
import {
  getSuggestionApi,
  upvoteQueryApi,
  fetchDataApi,
  modifySQLApi,
  sendPromptApi,
  sendLogApi,
} from './api';
import {
  ChartEmptyBlock,
  ErrorDataBlock,
  MessageBlock,
  RefreshBtn,
  SQLBlock,
} from './UtilComponents';
import { uniqueId } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import genieBotMessage from './messages';
import InputBox from '../UtilComponents/InputBox';
import { rootClsPrefix } from '../constants';
import { AiraFAB, AiraRound } from '../UtilComponents/Icons';
import { clsPrefix } from './constants';

export const AnalyticsBot = ({
  iconPlacement,
  ...rest
}) => {
  const onHide = () => {
    rest.actions.resetGenie();
  };
  return (
    <AiraContainer
      titlePadding="0.5rem"
      popupWidth="32rem"
      Icon={AiraFAB}
      iconSize="2.2rem"
      title="Aira Analytics Bot"
      titleDescription="AiRA, our proprietary AI tool, can help you with data analysis, visualization, and more."
      onHide={onHide}
      titleBarIcon={AiraRound}
      iconPlacement={iconPlacement}
    >
      <PopupContent {...rest} />
    </AiraContainer>
  )
}
const PopupContent = ({
  intl: { formatMessage },
  actions,
  messageDetails,
  textAskYourQuestion,
  getAPICallObject,
  request,
  orgId,
}) => {
  const { messageOrder, messages, session, dataFetching } = messageDetails;
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [lastQuery, setLastQuery] = useState();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuggest, setShowSuggest] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(undefined);
  const messageEnd = useRef(null);
  const inputRef = useRef(null);
  const [minimize, setMinimize] = useState(false);
  const [modifyFlag, setModifyFlag] = useState(false);
  const [rootPrompt, setRootPrompt] = useState('');
  const [queryOpen, setQueryOpen] = useState([]);
  const [dataProps, setDataProps] = useState({
    dataSource: [],
    columns: [],
    numCols: [],
  });
  const [graphSelects, setGraphSelects] = useState({});
  // const org_id = '150877'; only for testing purpose org_id will be dynamic
  useEffect(
    () => {
      if (messageEnd.current) {
        messageEnd.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    },
    [messages, showSuggest, suggestions],
  );

  useEffect(
    () => {
      if (
        modal &&
        currentMessage &&
        !currentMessage.response &&
        dataFetching !== 'REQUEST'
      )
        actions.fetchData(
          {
            id: currentMessage.id,
            query: currentMessage.query,
            org_id: orgId,
          },
          fetchDataApi(request, getAPICallObject),
        );
      else if (dataFetching === 'SUCCESS') {
        const columns = getTableColumns();
        const dataSource = modifyResponse();
        const numCols = getNumCols(dataSource[0], columns);
        setDataProps({ columns, dataSource, numCols });
      }
    },
    [currentMessage],
  );

  const getAnswer = async () => {
    if (query !== '') {
      if (!isEmpty(suggestions)) {
        setSuggestions([]);
        actions.cancelPrompt({ id: lastQuery?.id, prompt: lastQuery?.prompt });
      }
      const id = uniqueId();
      if (modifyFlag) {
        setRootPrompt(prompt => prompt + ', ' + query);
        actions.modifySQL(
          {
            id,
            prompt: query,
            org_id: orgId,
            prevQuery: modifyFlag.query,
            prevInterpret: modifyFlag.interpretation,
          },
          modifySQLApi(request, getAPICallObject),
        );
        setModifyFlag(false);
      } else {
        setRootPrompt(query);
        actions.getSuggestion(
          {
            id,
            prompt: query,
            org_id: orgId,
          },
          suggestionCallback,
          getSuggestionApi(request, getAPICallObject),
        );
      }
    }
    setQuery('');
  };
  const delay = async ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  const waitSuggestions = async () => {
    await delay(500);
    setShowSuggest(true);
  };

  // const focusInput = () => {
  //   if (inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // };

  const suggestionCallback = res => {
    const { id, prompt, suggestion: suggestions } = res;

    if (isEmpty(suggestions)) {
      actions.sendPrompt(
        {
          id,
          prompt,
          suggestions,
          suggested: 'ORIGINAL_PROMPT',
        },
        sendPromptApi(request, getAPICallObject),
      );
    } else {
      setLastQuery({ prompt, id, suggestions });
      setSuggestions([
        ...res.suggestion,
        { name: formatMessage(genieBotMessage.originalPrompt) },
      ]);
      waitSuggestions();
    }
  };
  const underscoreToTitleCase = inputString => {
    // Replace underscores with spaces
    const stringWithSpaces = inputString.replace(/_/g, ' ');

    // Title case the string
    const titleCaseString = stringWithSpaces.replace(/\w+/g, match => {
      return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
    });
    return titleCaseString;
  };

  function convertToCSV() {
    const columnHeaders = dataProps.columns.map(col => col.key);
    const array = [columnHeaders].concat(
      dataProps.dataSource.map(row => {
        return columnHeaders.map(col => row[col]);
      }),
    );

    const csv = array
      .map(it => {
        return Object.values(it).toString();
      })
      .join('\n');
    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (
      typeof URL !== 'undefined' &&
      typeof URL.createObjectURL === 'function'
    ) {
      var url = URL.createObjectURL(blob);
      // Further code that uses the created URL
    }

    // Create a link to download it
    var pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', 'export.csv');
    pom.click();
  }

  const getNumCols = (data, columns) => {
    const cols = data
      ? Object.keys(data).filter(
        key => !isNaN(data[key]) && !isNaN(parseFloat(data[key])),
      )
      : [];
    return columns.filter(col => cols.includes(col.key));
  };

  const getTableColumns = () => {
    const currentId = currentMessage?.id;
    const response = messages[currentId]?.column_index || [];
    const keys = response.map(key => ({
      key: key,
      dataIndex: key,
      title: underscoreToTitleCase(key),
      value: key,
      label: underscoreToTitleCase(key),
    }));
    return keys;
  };

  const modifyResponse = () => {
    const currentId = currentMessage?.id;
    const response = messages[currentId]?.response || {};
    const transposedData = [];
    if (!isEmpty(response)) {
      const keys = Object.keys(response);
      const numRows = Object.values(response[keys[0]]).length;
      for (let i = 0; i < numRows; i++) {
        const rowData = {};
        keys.forEach(key => {
          const val = response[key][i];
          rowData[key] = isNaN(val) ? val : parseFloat(val);
        });
        transposedData.push(rowData);
      }
    }
    return transposedData;
  };

  const tableProps = {
    className: `${clsPrefix}-data-table`,
    columns: dataProps.columns,
    dataSource: dataProps.dataSource,
    scroll: { x: 150 * dataProps.columns.length },
    tableLayout: 'auto',
    pagination: { pageSize: 7 },
  };

  const upvoteAnswer = () => {
    upvoteCallback('Thank you for your feedback!');
    actions.upvoteQuery(
      rootPrompt,
      currentMessage.query,
      undefined,
      'LIKE',
      upvoteQueryApi(request, getAPICallObject),
    );
  };
  const downvoteAnswer = () => {
    upvoteCallback('Thank you for your feedback!');
    actions.upvoteQuery(
      rootPrompt,
      currentMessage.query,
      undefined,
      'DISLIKE',
      upvoteQueryApi(request, getAPICallObject),
    );
  };
  const upvoteCallback = result => {
    CapNotification.success({
      message: result,
    });
  };
  const handleSubmit = e => {
    getAnswer();
  };

  useEffect(
    () => {
      if (dataFetching === 'SUCCESS') {
        const columns = getTableColumns();
        const dataSource = modifyResponse();
        const numCols = getNumCols(dataSource[0], columns);
        setDataProps({ columns, dataSource, numCols });
      }
    },
    [dataFetching],
  );

  const submitSuggest = value => {
    if (value.name === 'Use Original Prompt') {
      actions.sendPrompt(
        {
          ...lastQuery,
          suggested: 'ORIGINAL_PROMPT',
        },
        sendPromptApi(request, getAPICallObject),
      );
    } else {
      actions.sendPrompt(
        {
          id: lastQuery?.id,
          prompt: lastQuery?.prompt,
          suggestions: lastQuery?.suggestions,
          suggested: value?.name,
        },
        sendPromptApi(request, getAPICallObject),
      );
    }
    setSuggestions([]);
  };

  const chartOptions = [
    { value: 'intervalStack', key: 'Bar', label: 'Bar' },
    { value: 'line', key: 'Line', label: 'Line' },
  ];

  const handleColumnSelect = (name, value) => {
    const extra = {};
    if (name === 'column2' && !graphSelects.column3) {
      extra.column3 = value;
    }
    setGraphSelects(prev => ({
      ...prev,
      [name]: value,
      ...extra,
    }));
  };

  const showModal = id => {
    setModal(true);
    setCurrentMessage(messages[id]);
    if (dataFetching === 'FAILURE') actions.setFetchStatus({ id });
  };
  const refreshData = () => {
    actions.fetchData(
      {
        id: currentMessage.id,
        query: currentMessage.query,
        org_id: orgId,
      },
      fetchDataApi(request, getAPICallObject),
    );
  };

  const chartProps = {
    height: 380,
    chartProps: {
      width: 600,
      padding: 'auto',
    },
    data: dataProps.dataSource,
    xAxis: graphSelects.column1,
    yAxis: graphSelects.column2,
    legend: {
      marker: 'circle',
      position: 'bottom-left',
    },
    graphList: [
      {
        type: graphSelects?.type || 'line',
        colors: [
          '#1984c5',
          '#22a7f0',
          '#63bff0',
          '#a7d5ed',
          '#e2e2e2',
          '#e1a692',
          '#de6e56',
          '#e14b31',
          '#c23728',
        ],
        groupBy: graphSelects?.column3 || graphSelects?.column2,
      },
    ],
  };

  const openFTPLink = link => {
    window.open(link, '_blank', 'noreferrer');
  };

  const handleModalOk = async () => {
    setModifyFlag(currentMessage);
    handleModalClose();
    await delay(100);
    // focusInput();
  };
  const handleModalClose = () => {
    setModal(false);
    setQueryOpen([]);
    setGraphSelects({});
  };

  const cancelModify = () => {
    setModifyFlag(false);
  };

  const handleDownloadImage = () => {
    var link = document.createElement('a');
    link.download = 'chart.png';
    link.href = document.querySelectorAll('canvas')[0].toDataURL();
    link.click();
  };

  const handleModify = id => {
    // setCurrentMessage(messages[id]);
    setRootPrompt(messages[id].prompt);
    setModifyFlag(messages[id]);
    // focusInput();
  };

  return (
    <div className={`${clsPrefix}-root`}>
      {!minimize && (
        <div className={`${clsPrefix}-content`}>
          <div
            className={`${clsPrefix}-answer-container ${rootClsPrefix}-no-scrollbar`}
          >
            {
              <>
                <CapRow className={`${clsPrefix}-message-received`}>
                  {formatMessage(genieBotMessage['openingSentence'])}
                </CapRow>

                {messageOrder?.map(id => (
                  <MessageBlock
                    message={messages[id]}
                    showModal={showModal}
                    handleModify={handleModify}
                  />
                ))}
                {!isEmpty(suggestions) && (
                  <>
                    <CapRow className={`${clsPrefix}-message-sent`}>
                      {lastQuery?.prompt}
                    </CapRow>
                    {showSuggest && (
                      <>
                        <CapRow className={`${clsPrefix}-did-you-mean`}>
                          Do you mean?
                        </CapRow>
                        <CapRow
                          type="flex"
                          className={`${clsPrefix}-suggest-container`}
                        >
                          {suggestions.map(item => {
                            const handleSuggest = () => {
                              submitSuggest(item);
                            };
                            return (
                              <CapColoredTag
                                tagColor="lightgrey"
                                tagTextColor="black"
                                className={`${clsPrefix}-suggestion`}
                                onClick={handleSuggest}
                              >
                                {item.name}
                              </CapColoredTag>
                            );
                          })}
                        </CapRow>
                      </>
                    )}
                  </>
                )}
                <div ref={messageEnd} />
              </>
            }
          </div>
          {modifyFlag && (
            <CapRow
              type="flex"
              align="middle"
              justify="space-between"
              className={`${clsPrefix}-modify-block`}
            >
              <CapRow className={`${clsPrefix}-modify-text`}>
                <b>Modification for:</b> {modifyFlag.prompt}
              </CapRow>
              <CapIcon type="close" onClick={cancelModify} />
            </CapRow>
          )}
          <InputBox
            value={query}
            setValue={setQuery}
            showSend={query == lastQuery}
            loading={loading}
            placeholder={textAskYourQuestion}
            onSubmit={handleSubmit}
          />
        </div>
      )}
      <CapModal
        getContainer={() => document.querySelector(`.${clsPrefix}-root`)}
        title="Data Response"
        visible={modal}
        onCancel={handleModalClose}
        footer={
          <div className="default-footer">
            <CapButton onClick={handleModalOk} type="primary">
              Modify Current Query
            </CapButton>
            <CapButton onClick={handleModalClose} type={'flat'}>
              Continue with New Prompt
            </CapButton>
          </div>
        }
        className={`${clsPrefix}-modal-popup`}
      >
        {' '}
        <CapRow type="flex" className={`${clsPrefix}-modal-body`}>
          {dataFetching === 'REQUEST' ? (
            <CapSkeleton active />
          ) : dataFetching === 'SUCCESS' ? (
            messages[(currentMessage?.id)]?.piData ? (
              <ErrorDataBlock
                title="The Following Data contains personal information."
                desc="You can access it below using the FTP Export Link"
                type="PI"
                linkMsg="Check Export Here"
                link={messages[currentMessage.id].ftp_link}
              />
            ) : (
              <>
                <CapRow type="flex" className={`${clsPrefix}-data-container`}>
                  <CapRow className={`${clsPrefix}-data-child table-container`}>
                    <CapTable {...tableProps} />
                    <RefreshBtn refreshData={refreshData} />
                    <CapTooltip title="Download Data">
                      <CapIcon
                        type="download"
                        size="s"
                        className={`${clsPrefix}-download-data`}
                        withBackground={true}
                        onClick={convertToCSV}
                        data-testid="download-data"
                      />
                    </CapTooltip>
                  </CapRow>
                  {dataProps.columns.length > 1 &&
                    dataProps.numCols.length > 0 ? (
                    <CapRow
                      type="flex"
                      className={`${clsPrefix}-data-child chart-container`}
                    >
                      <CapRow
                        type="flex"
                        className={`${clsPrefix}-chart-filters`}
                      >
                        {' '}
                        <CapSelect
                          label="Type"
                          placeholder="Select Type"
                          style={{ width: '150px' }}
                          options={chartOptions}
                          getPopupContainer={() =>
                            document.querySelector(`.${clsPrefix}-modal-popup`)
                          }
                          value={graphSelects?.type}
                          onChange={value => handleColumnSelect('type', value)}
                        />
                        <CapSelect
                          label="X-Axis"
                          placeholder="Select Column"
                          style={{ width: '150px' }}
                          options={dataProps.columns}
                          value={graphSelects?.column1}
                          getPopupContainer={() =>
                            document.querySelector(`.${clsPrefix}-modal-popup`)
                          }
                          onChange={value =>
                            handleColumnSelect('column1', value)
                          }
                        />
                        <CapSelect
                          label="Y-Axis"
                          placeholder="Select Column"
                          style={{ width: '150px' }}
                          options={dataProps.numCols}
                          value={graphSelects?.column2}
                          getPopupContainer={() =>
                            document.querySelector(`.${clsPrefix}-modal-popup`)
                          }
                          onChange={value =>
                            handleColumnSelect('column2', value)
                          }
                        />
                        <CapSelect
                          label="Group By"
                          placeholder="Select Column"
                          style={{ width: '150px' }}
                          options={dataProps.columns}
                          value={graphSelects?.column3}
                          getPopupContainer={() =>
                            document.querySelector(`.${clsPrefix}-modal-popup`)
                          }
                          onChange={value =>
                            handleColumnSelect('column3', value)
                          }
                        />
                      </CapRow>
                      {graphSelects.column1 && graphSelects.column2 ? (
                        <CapRow>
                          <CapGraph {...chartProps} />
                          <CapIcon
                            type="download"
                            size="s"
                            className={`${clsPrefix}-refresh-data`}
                            withBackground={true}
                            onClick={handleDownloadImage}
                            data-testid="download-chart"
                          />
                        </CapRow>
                      ) : (
                        <ChartEmptyBlock
                          title="Apply the filters to view your chart."
                          desc="Visualize the data with charts now!"
                          chartIcon
                        />
                      )}
                    </CapRow>
                  ) : (
                    <CapRow type="flex" className={`${clsPrefix}-data-child`}>
                      <ChartEmptyBlock
                        title="Looks like the data is not sufficient to visualize"
                        desc="Try again with some other prompts."
                      />
                    </CapRow>
                  )}
                </CapRow>
                {dataProps.dataSource.length === 100 && (
                  <CapInfoNote
                    message={
                      <span style={{ display: 'inline-flex' }}>
                        The data on this page is limited to 100 records. For
                        full data, use this link.
                        <CapLink
                          onClick={() =>
                            openFTPLink(messages[currentMessage.id].ftp_link)
                          }
                          title={
                            <CapRow type="flex" align="middle">
                              Open FTP Export!
                              <CapIcon
                                style={{ fontSize: '14px' }}
                                type="open-in-new-light"
                              />
                            </CapRow>
                          }
                        />
                      </span>
                    }
                  />
                )}
              </>
            )
          ) : (
            <div className={`${clsPrefix}-data-container`}>
              <ErrorDataBlock
                title="There was some issue getting the response"
                desc="You can refresh to retry or try again with a different prompt."
              />
              <RefreshBtn refreshData={refreshData} />
            </div>
          )}

          <CapRow type="flex">
            <CapStepsAccordian
              showNumberSteps={false}
              activeKey={queryOpen}
              onChange={() =>
                setQueryOpen(prev => (prev.length > 0 ? [] : [1]))
              }
              items={[
                {
                  header: (
                    <CapRow type="flex" className={`${clsPrefix}-accordion`}>
                      <CapHeader size="regular" title="Show SQL Query" />
                      <CapRow
                        type="flex"
                        align="middle"
                        style={{ gap: '8px' }}
                        onClick={event => event.stopPropagation()}
                      >
                        <CapLabel type="label16">
                          Did you find the data useful?{' '}
                        </CapLabel>
                        <CapButton
                          className={`${clsPrefix}-modal-btn like`}
                          onClick={upvoteAnswer}
                        >
                          <CapIcon
                            type="like"
                            theme="filled"
                            className="feedback-icon"
                          />
                        </CapButton>
                        <CapButton
                          className={`${clsPrefix}-modal-btn dislike`}
                          onClick={downvoteAnswer}
                        >
                          <CapIcon
                            type="dislike"
                            theme="filled"
                            className="feedback-icon"
                          />
                        </CapButton>
                      </CapRow>
                    </CapRow>
                  ),
                  content: (
                    <div>
                      <SQLBlock query={currentMessage?.query} />
                    </div>
                  ),
                  key: 1,
                  completed: true,
                  onChange: () => setQueryOpen(prev => [1]),
                },
              ]}
            />
          </CapRow>
        </CapRow>
      </CapModal>
    </div>
  );
};
AnalyticsBot.defaultProps = {
  sendPromptApi: () => { },
  modifySQLApi: () => { },
  fetchDataApi: () => { },
  getSuggestionApi: () => { },
  upvoteQueryApi: () => { },
  messageDetails: {},
};
const mapStateToProps = createStructuredSelector({
  messageDetails: makeSelectMessageDetail(),
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(action, dispatch),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(
  LocaleHoc(AnalyticsBot, {
    key: 'CapAskAira.AnalyticsBot',
  }),
);
